import { PHONE, locationSchema } from "../structured-data-core";

export function getEdinaStructuredData() {
  const url = "https://restorehair.com/locations/minnesota/edina/";
  const description =
    "Find out about your hair transplant options in Edina with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Edina", "5201 Eden Ave, Suite 300", "Edina", "MN", PHONE, url, description),
  ];
}
